var map = {
	"./0.svg": 5315,
	"./1.svg": 8311,
	"./2.svg": 7524,
	"./3.svg": 1850,
	"./4.svg": 1530,
	"./5.svg": 5394,
	"./6.svg": 9594,
	"./7.svg": 5867,
	"./8.svg": 7986,
	"./9.svg": 7473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3045;